import { Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
const SendButton: React.FC<any> = ({ stageRef }) => {
  const postURL: string = process.env.REACT_APP_POSTIMAGE_URL || "localhost"; //TODO:基本的に設定する。ダメなときエラー出す
  const { t } = useTranslation();
  const submit = () => {
    const currentStageRef: any = stageRef.current;
    console.log(currentStageRef);
    //TODO:img作成
    const imginput = document.createElement("input");

    imginput.type = "text";
    imginput.name = "fileImg";
    imginput.value = currentStageRef.toDataURL({ pixelRatio: 1 });

    document.body.append(imginput);

    //form作成
    const form = document.createElement("form");
    form.action = postURL;
    form.method = "post";
    form.encType = "multipart/form-data";
    form.append(imginput);
    document.body.append(form);
    form.submit();
  };
  return (
    <>
      <Grid item>
        <Button
          variant="contained"
          onClick={submit}
          color="secondary"
          fullWidth
        >
          {t("actionButtons.tweetImage")}
        </Button>
      </Grid>
    </>
  );
};

export default SendButton;
